class PosPaperApp {
    constructor() {
        this.type = 'index';
        this.product = null;
        this.form = null;
        this.apiUrl = 'https://shopify.pospaper.com/';
        if(window.Theme && window.Theme.pageType) {
            if(window.Theme.pageType.includes('product')) {
                this.type = 'pdp';
            }
            if(window.Theme.pageType.includes('collection')) {
                this.type = 'plp';
            }
        }
        this.fetchConfig = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json', 'Cache-Control': 'no-store,no-cache, must-revalidate, post-check=0, pre-check=0' }
        };
        this.swipers = [];
        this.productData = {
            tierPrices: []
        };
        this.body = document.querySelector('body');
        this._initEvents();
        this._initQty();
        this._initSwipers();
        switch(this.type) {
            case 'pdp':
                this._initPdp();
                break;
            case 'plp':
                this._initPlp();
                break;
            default:
                break;
        }
    }

    _initEvents() {
        const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

        dropdownToggles.forEach(toggle => {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                const parentItem = toggle.closest('.has-dropdown');
                const isExpanded = parentItem.getAttribute('aria-expanded') === 'true';

                // Close all other dropdowns
                document.querySelectorAll('.has-dropdown[aria-expanded="true"]').forEach(item => {
                    item.setAttribute('aria-expanded', 'false');
                });

                // Toggle the current dropdown
                parentItem.setAttribute('aria-expanded', !isExpanded);
            });
        });
    }

    _initQty() {
        let qtyWrappers = document.querySelectorAll('[data-quantity-wrapper]');
        if(qtyWrappers.length > 0) {
            qtyWrappers.forEach(qtyWrapper => {
                let buttons = qtyWrapper.querySelectorAll('input[type="button"]');
                buttons.forEach(button => {
                    button.addEventListener('click',(event) => {
                        event.preventDefault();

                        var eventTarget = event.target,
                            formField = eventTarget.closest('.form-field'),
                            qtyInput = formField.querySelector('input[type="number"]'),
                            qty = 0,
                            origQty = parseInt(qtyInput.value),
                            minAllowed = qtyInput.getAttribute('min') ? parseInt(qtyInput.getAttribute('min')) : 1,
                            qtyIncrements = qtyInput.getAttribute('step') ? parseInt(qtyInput.getAttribute('step')) : 1;

                        if(eventTarget.classList.contains('qtyplus')) {
                            qty = (Math.ceil(origQty / qtyIncrements) * qtyIncrements) + qtyIncrements;
                        } else {
                            qty = (Math.ceil(origQty / qtyIncrements) * qtyIncrements) - qtyIncrements;
                        }
                        if(qty < minAllowed) {
                            qty = minAllowed;
                        }
                        qtyInput.value = qty;
                        if(qty != origQty) {
                            var event = new Event('change');
                            qtyInput.dispatchEvent(event);
                            $(qtyInput).trigger('change.cart-page');
                        }
                    });
                });
            });
        }
    }

    _initPlp() {
        let filtersMore = document.querySelectorAll('.filters__filter-show-more');
        if(filtersMore.length > 0) {
            filtersMore.forEach((filterMore) => {
                filterMore.addEventListener('click',(e) => {
                    let target = e.target;
                    const text = target.innerText;
                    const parent = filterMore.closest('.collection-filters__filter-list');
                    let filters = parent.querySelectorAll('.hidden-filter');
                    filters.forEach((filter) => {
                        if(text === 'Show More') {
                            filter.classList.add('show');
                            target.innerText = 'Show Less';
                        } else {
                            filter.classList.remove('show');
                            target.innerText = 'Show More';
                        }
                    })
                })
            });
        }
    }

    _initPdp() {
        const sectionData = document.querySelector('[data-section-type="static-product"]').innerHTML;
        const staticProduct = JSON.parse(sectionData);
        this.product = staticProduct.product;
        const sku = this.product.variants[0].sku;
        this._getCompatibleModels(sku);
        this.form = document.querySelector('[data-product-form]');
        var quantityInput = this.form.querySelector('input[name="quantity"]');
        if(window.Product && window.Product.tierPrices) {
            this._updateTierPrices();
            quantityInput.addEventListener('change', (e) => {
                var variants = this.form.querySelector('select[name="id"]'),
                    eventTarget = e.target,
                    qty = parseInt(eventTarget.value),
                    price = window.Product.price,
                    subscriptionPrice = (window.Product.price * .95),
                    priceContainers = document.querySelectorAll('.product-main [data-main-product-price]'),
                    subscriptionPriceContainers = document.querySelectorAll('.product-main [data-subscription-product-price]');
                console.log('this.productData.tierPrices',this.productData.tierPrices);
                this.productData.tierPrices.forEach((priceData,index) => {
                    if(qty >= priceData.min && qty <= priceData.max) {
                        price = priceData.price;
                        subscriptionPrice = (price * .95);
                        return false;
                    }
                });
                priceContainers.forEach((priceContainer) => {
                    priceContainer.innerText = '$' + price;
                });
                subscriptionPriceContainers.forEach((subscriptionPriceContainer) => {
                    subscriptionPriceContainer.innerText = '$' + subscriptionPrice.toFixed(2);
                });
                var variant = variants.querySelector('[data-price="'+price+'"]');
                if(variant) {
                    variants.value = variant.getAttribute('value');
                    console.log('variants.value',variants.value);
                    var event = new Event('change');
                    variants.dispatchEvent(event);
                }
            });
        } else {
            this.form.classList.remove('loading');
        }

        this._initForm('.ajax-contact-form');
    }

    _getUrlString(data) {
        var urlParameters = Object.entries(data).map(function (e) {
            return e.join('=');
        }).join('&');
        return urlParameters;
    }

    _formToJSON(elements) {
        return [].reduce.call(elements, function (data, element) {
            data[element.name] = element.value;
            return data;
        }, {});
    }

    _initForm(selector) {
        selector = selector || '.contact-form';

        document.querySelectorAll(selector).forEach((form) => {
            var action = form.getAttribute("data-action"),
                alert = form.querySelector('[data-alert="status"]'),
                inputs = form.querySelectorAll("[name]");

            // Submit data via Fetch
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                fetch(action, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json"
                    },
                    body: this._getUrlString(this._formToJSON(inputs))
                }).then(function(response) {
                    console.log(response);
                    console.log("Response Status: " + response.status);
                    alert.className = "alert alert-success";
                    alert.innerHTML = "Thank you for contacting us. We will be in touch.";
                }).catch(function(error) {
                    console.log(error);
                    console.log("Response Status: " + response.status);
                    alert.className = "alert alert-danger";
                    alert.innerHTML = "We had an issue receiving your form. Please try again later.";
                });
            });
        });
    }

    _updateTierPrices() {
        var productId = document.querySelector('[name="product_id"]').value,
            idField = this.form.querySelector('[name="id"]'),
            priceMax = this.form.querySelector('[name="product_price_max"]').value,
            defVariant = this.form.querySelector('[name="product_default_variant"]').value,
            defSku = this.form.querySelector('[name="product_default_sku"]').value,
            parentContainer = document.querySelector('[data-product-tier-prices]'),
            tierTable = document.createElement('table'),
            tierTableHtml = '',
            selectElHtml = '',
            prices = [],
            total = 0;

        tierTableHtml = '<tr><th>Quantity</th><th>Price</th><th>Discount</th></tr>';

        for(const qty in window.Product.tierPrices) {
            prices.push({'qty':qty, 'price':window.Product.tierPrices[qty]});
        }
        total = prices.length;
        const variants = this.product.variants.filter(v => v.title !== 'Default Title');
        console.log('variants',variants);
        if(variants.length !== total) {
            total = variants.length;
        }
        if(total > 0) {
            selectElHtml += '<option value="'+defVariant+'" data-price="'+priceMax+'" selected="selected">Default Title</option>';
            variants.forEach((data, index) => {
                if(typeof data === 'object' && data !== null) {
                    var qtyLabel = data.option1,
                        price = (data.price/100),
                        priceStr = price.toFixed(2),
                        productData = {min:0,max:0,price:0};
                    if(index < (total-1)) {
                        qtyLabel = qtyLabel + ' - ' + (parseInt(variants[index+1].option1) -1);
                        productData.min = parseInt(data.option1);
                        productData.max = parseInt(variants[index+1].option1) -1;
                        productData.price = priceStr;
                    } else {
                        qtyLabel += ' +';
                    }
                    if(index === 0) {
                        productData.min = parseInt(data.option1);
                    }
                    if(index === (total-1)) {
                        productData.min = parseInt(data.option1);
                        productData.max = 999999;
                        productData.price = priceStr;
                    }
                    var discount = this._calculateDiscount(window.Product.price, price)
                    tierTableHtml += `<tr><td>${qtyLabel}</td><td><strong>$${priceStr}</strong> / ${window.Product.unitOfMeasure}</td><td>Save ${discount}%</td></tr>`;
                    this.productData.tierPrices.push(productData);
                    selectElHtml += '<option value="'+data.id+'" data-price="'+priceStr+'">'+data.option1+'</option>';
                }
            });
            tierTableHtml += `<tr><td colspan="3"><a href="#modal-contact-form" class="open-contact-modal-link">Looking for larger quantities with deeper discounts?</a></td></tr>`;
            tierTable.innerHTML = tierTableHtml;
            parentContainer.appendChild(tierTable);
            console.log(idField.nodeName);
            if(idField.nodeName !== 'SELECT') {
                var selectEl = document.createElement('select');
                selectEl.setAttribute('name', 'id');
                selectEl.setAttribute('data-product-option', '');
                selectEl.setAttribute('data-variants','');
                selectEl.innerHTML = selectElHtml;
                idField.parentNode.replaceChild(selectEl,idField);
            } else {
                idField.innerHTML = selectElHtml;
            }
            parentContainer.classList.add('show');
            this.form.classList.remove('loading');
            setTimeout(() => {
                this._createRechargeWidget(productId);
            },1000);
        }
    }

    _createRechargeWidget(id) {
        if(this.product !== undefined && this.product.selling_plan_groups !== undefined && this.product.selling_plan_groups.length > 0) {
            const product = this.product;
            const sellingPlans = product.selling_plan_groups[0].selling_plans;
            const price = (product.price_max / 100);
            const subscriptionPrice = (price * .95);
            console.log('product',product);
            let subscriptionWrapper = document.createElement('div');
            subscriptionWrapper.setAttribute('class','subscriptions-wrapper tooltip-wrapper');
            let plansHtml =
                '    <div class="subscription-types">\n' +
                '        <div>\n' +
                '            <input type="radio" name="purchase_type" value="onetime" id="purchase_type_onetime" checked>\n' +
                '            <label for="purchase_type_onetime">One-time purchase: <span data-main-product-price>$'+price.toFixed(2)+'</span></label>\n' +
                '        </div>\n' +
                '        <div>\n' +
                '            <input type="radio" name="purchase_type" value="subscription" id="purchase_type_subscription">\n' +
                '            <label for="purchase_type_subscription">Subscribe & Save (5%): <span data-subscription-product-price>$'+subscriptionPrice.toFixed(2)+'</span> <a href="#" class="learn-more-link">Learn more</a></label>\n' +
                '            <div class="subscription-options">\n' +
                '                <label for="subscription-options">Deliver every</label>\n' +
                '            </div>\n' +
                '        </div>\n' +
                '    </div>\n' +
                '   <span class="tooltip-content">\n' +
                '       <a href="#" class="tooltip-close"></a>\n' +
                '       <strong>Choose how often it\'s delivered</strong>\n' +
                '       <span>From once per month to every four months</span>\n' +
                '       <br>\n' +
                '       <strong>Skip or cancel any time</strong>\n' +
                '       <span>Pause or cancel your auto-deliveries at any time</span>\n' +
                '   </span>';
            subscriptionWrapper.innerHTML = plansHtml;
            let options = document.createElement('select');
            options.setAttribute('id','subscription-options');
            options.setAttribute('name','shipping_interval_frequency');
            let optionsHtml = '<select id="subscription-options" name="shipping_interval_frequency">';
            sellingPlans.forEach((sellingPlan, index) => {
                const planName = sellingPlan.name.replace('Delivery every ','');
                optionsHtml += '<option value="'+sellingPlan.id+'">'+planName+'</option>';
            });
            optionsHtml += '</select>';
            options.innerHTML = optionsHtml;
            this.form.prepend(subscriptionWrapper);
            this.form.querySelector('.subscription-options').appendChild(options);
        }
    }

    _calculateDiscount(oldPrice, newPrice) {
        var price = Math.round(100 - ((100/oldPrice) * newPrice));
        return price.toFixed(0);
    }

    _getVariantsFromApi(sku) {
        var data = {
            handle: window.Product.handle,
            qty: window.Product.availableQty,
            sku: sku
        };
        for(const qty in window.Product.tierPrices) {
            data['prices['+qty+']'] = window.Product.tierPrices[qty];
        }
        var body = this._getRequestBody(data),
            t = Math.floor(Math.random() * 9e9);
        return new Promise((resolve, reject) => {
            fetch(`${this.apiUrl + 'pos/variants?t=' + t}`, {...this.fetchConfig, ...{ body }})
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    resolve(JSON.parse(state))
                })
                .catch((error) => {
                    reject(error)
                });
        })
    }

    _getCompatibleModels(sku) {
        var container = document.querySelector('[data-compatible-item-numbers]');
        if(!container) {
            return;
        }

        fetch('https://cdn.shopify.com/s/files/1/0562/3686/7721/files/compatibility.json')
            .then((response) => {
                return response.text();
            })
            .then((response) => {
                try {
                    const compatibility = JSON.parse(response);
                    const records = compatibility.filter(item => item.product_ids.split(',').includes(sku));
                    const models = {};
                    records.forEach((record) => {
                        if(!models.hasOwnProperty(record.manufacturer)) {
                            models[record.manufacturer] = [];
                        }
                        models[record.manufacturer].push(record.model);
                    });
                    if(Object.keys(models).length > 0) {
                        const el = document.createElement('ul');
                        for(const brand in models) {
                            const modelsStr = models[brand].join(', ');
                            el.innerHTML += `<li class="manu-bold"><strong>${brand}:</strong> <span class="manu-space">${modelsStr}</span></li>`;
                        }
                        container.appendChild(el);
                    }
                } catch (e) {

                }
            });
    }

    _getRequestBody(data) {
        var formBody = [];
        for (var property in data) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(data[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        return formBody;
    }

    _initSwipers() {
        const swipers = document.querySelectorAll('[data-layout="swiper"]');
        if(swipers.length > 0) {
            swipers.forEach((el) => {
                const swiper = new Swiper(el, {
                    loop: true,
                    slidesPerView: 2,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 20
                        }
                    }
                });
                this.swipers.push(swiper);
            });
        }
    }
}

window.onload = () => {
    new PosPaperApp();
}

window.addEventListener('DOMContentLoaded', () => {
    let heroSlideshow = null;
    const heroSlideshowEl = document.querySelector('.hero-slideshow');

    if(heroSlideshowEl) {
        heroSlideshow = new Swiper('.hero-slideshow .swiper', {
            loop: true,
            autoplay: {
                delay: 2000,
                pauseOnMouseEnter: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
})

window.addEventListener('DOMContentLoaded', function(){
    let has_child_links = document.querySelectorAll('.plus--icosns');
    let more__btn = document.querySelector('.Collapsible--content-btn-wrapper');
        has_child_links.forEach((link) => {
          link.addEventListener("click", function(e){

            e.target.parentElement.parentElement.classList.toggle("submenu_active")
          })
        })
});
